module.exports = __webpack_public_path__ + "static/media/stripe.c6ce9f11.svg";